import type { CityConfig } from "../city-template/types";

export const vermillionConfig: CityConfig = {
  city: "Vermillion",
  state: "South Dakota",
  stateAbbr: "SD",
  slug: "vermillion",
  route: "/vermillion",
  title: "Emergency Passport Vermillion, SD — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Vermillion, SD — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Vermillion residents, USD Coyote students and faculty, Clay County professionals, and southeastern South Dakota travelers.",
  h1: "Emergency & Expedited Passport Services in Vermillion, SD",
  heroSubtitle: "USD study abroad program starting next week? International research conference in two weeks? Coyote athletic department recruiting trip to Europe coming up? We help Vermillion residents — from University of South Dakota students and faculty to Missouri River recreation families to Clay County professionals — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Panoramic%20view%20of%20the%20University%20of%20South%20Dakota%20campus%20in%20Vermillion%20South%20Dakota%20with%20Old%20Main%20building%20featuring%20its%20distinctive%20red%20brick%20architecture%20and%20clock%20tower%2C%20the%20Missouri%20River%20in%20the%20background%20with%20cottonwood%20trees%20along%20the%20riverbank%2C%20USD%20Coyote%20red%20banners%20and%20manicured%20green%20campus%20lawns%20under%20a%20bright%20prairie%20sky%20with%20scattered%20clouds%2C%20collegiate%20atmosphere%20in%20a%20historic%20river%20town%20setting&width=1800&height=700&seq=vermillion-hero-2026&orientation=landscape",
  heroImageAlt: "University of South Dakota campus and Missouri River in Vermillion South Dakota",
  geoPosition: "42.7794;-96.9292",
  geoPlacename: "Vermillion, South Dakota",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Located approximately 280 miles northeast of Vermillion via I-29 — appointments required, typically booked 2+ weeks out",
  },
  nearbyCitiesZips: [
    { name: "Vermillion", zips: "57069" },
    { name: "Yankton", zips: "57078" },
    { name: "Elk Point", zips: "57025" },
    { name: "Beresford", zips: "57004" },
    { name: "Wakonda", zips: "57073" },
    { name: "Irene", zips: "57037" },
    { name: "Gayville", zips: "57031" },
    { name: "Meckling", zips: "57044" },
    { name: "Burbank", zips: "57010" },
    { name: "Jefferson", zips: "57038" },
    { name: "North Sioux City", zips: "57049" },
    { name: "Dakota Dunes", zips: "57049" },
    { name: "Ponca, NE", zips: "68770" },
    { name: "Newcastle, NE", zips: "68757" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Emergency Processing", desc: "Reserved courier access to the Minneapolis Passport Agency — as fast as 24 hours for Vermillion-area travelers with immediate departures." },
    { icon: "ri-graduation-cap-line", title: "USD Coyote Student & Faculty Support", desc: "University of South Dakota study abroad, research conferences, and athletic department international travel — we understand university timelines and the academic calendar." },
    { icon: "ri-flight-takeoff-line", title: "Dual Airport Access", desc: "Sioux Gateway Airport (SUX, 35 mi south in Sioux City, IA) and Sioux Falls Regional Airport (FSD, 60 mi north) provide two regional airport options for international connections." },
    { icon: "ri-anchor-line", title: "Missouri River Recreation", desc: "The Missouri National Recreational River runs past Vermillion, drawing outdoor recreation professionals and international visitors — we help Vermillion residents travel abroad too." },
  ],
  internalLinks: [
    { name: "Fast passport services in Sioux Falls, SD", route: "/sioux-falls" },
    { name: "Quick passport services in Yankton, SD", route: "/yankton" },
    { name: "Expedited passport in Sioux City, IA", route: "/sioux-city" },
    { name: "Urgent passport services in Brookings, SD", route: "/brookings" },
    { name: "South Dakota passport services overview", route: "/south-dakota" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Vermillion via secure registered courier with direct access to the Minneapolis Passport Agency at 212 3rd Ave S, Minneapolis. Our registered couriers hand-deliver your documents — meaning you get faster results without the 280-mile drive. Vermillion residents can ship from any UPS Store, FedEx Office, or post office location across Clay County.",
  fpcOfficeDistance: "Serving Vermillion, Elk Point, Beresford, Wakonda, Irene, and all Clay County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Vermillion and Clay County. From the USD campus and downtown Main Street to the Missouri River bluffs and surrounding agricultural communities — we serve all of southeastern South Dakota. Our courier service eliminates the need to drive nearly five hours to the Minneapolis Passport Agency or wait for a post office appointment.",
  nearbyCitiesIntro: "We serve Vermillion and surrounding communities including Yankton, Elk Point, Beresford, Wakonda, and Irene. We also serve travelers departing from Sioux Gateway Airport (SUX) and Sioux Falls Regional Airport (FSD) who need expedited passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Vermillion as simple as possible — with the efficiency and reliability USD students, Clay County professionals, and Missouri River families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Vermillion travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Vermillion travelers encounter unique passport issues — everything from USD study abroad deadlines to international academic conference travel to 6-month validity rules for European destinations. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Vermillion travelers — from USD Coyotes to Clay County families to Missouri River recreation professionals — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Vermillion, SD? Here are the most common ones we hear from Clay County travelers.",
  statePageRoute: "/states/south-dakota",
  statePageName: "South Dakota",
  servicesIntro: "Whether you need a renewal before a USD study abroad program, an emergency passport for an international research conference, or a first-time passport for a family heritage trip — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dps.sd.gov/driver-licensing",
  dmvLabel: "South Dakota DPS Driver Licensing — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "USD study abroad departing in 3 days? International research conference this week? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Vermillion-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Vermillion residents renew fast — no agency visit required for most renewals. Perfect for USD faculty, Clay County professionals, and Missouri River families.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Vermillion residents through every step — from USD freshmen to Clay County families — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your USD trip or academic conference is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your family trip abroad or heritage tour stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Vermillion residents after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for USD researchers and Clay County business owners who travel abroad while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Vermillion-area travelers through the process so your international itinerary stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. We expedite passport card applications with the same courier service as book passports.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Vermillion SD", description: "Urgent passport processing for Vermillion South Dakota travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Vermillion SD", description: "Fast passport renewal for Vermillion South Dakota residents with a previously-issued passport." },
    { name: "First-Time Passport Vermillion SD", description: "New passport application services for Vermillion South Dakota residents applying for their first passport." },
    { name: "Child Passport Vermillion SD", description: "Minor passport services for Vermillion South Dakota families with children under 16." },
    { name: "Name Change Passport Vermillion SD", description: "Passport name correction after marriage, divorce, or legal name changes for Vermillion residents." },
    { name: "Second Passport Vermillion SD", description: "Second passport services for USD researchers and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Megan H.",
      location: "USD Student, Vermillion",
      rating: 5,
      text: "I was accepted to a medical service trip in Guatemala with only 2 weeks to get a passport. I had never applied for one. Fast Passport Center walked me through everything and it arrived in time. Life-changing experience.",
      service: "First-Time Passport",
    },
    {
      name: "Dr. Paul R.",
      location: "USD Professor, Vermillion",
      rating: 5,
      text: "I had a keynote presentation at a conference in Switzerland. My passport expired and I did not notice until 10 days before my flight. They got it done in 5 days. I delivered the keynote without a hitch.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "The Nguyen Family",
      location: "Clay County",
      rating: 5,
      text: "We planned a multigenerational trip to Vietnam. Our parents needed renewals and our daughter needed a first passport. Fast Passport Center handled all four applications seamlessly. We all made the trip together.",
      service: "Family Passports",
    },
    {
      name: "Coach Tim L.",
      location: "USD Athletics, Vermillion",
      rating: 5,
      text: "International recruiting trip to Europe came up fast. My passport was expired. They renewed it in 4 days. I was on the plane to Frankfurt with time to spare. Unreal service.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "vermillion-1",
      name: "Vermillion Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "16 N Dakota St",
      city: "Vermillion",
      state: "SD",
      zip: "57069",
      phone: "(605) 624-4501",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Downtown Vermillion",
      website: "https://tools.usps.com/find-location.htm?location=1368547",
      websiteLabel: "USPS Location",
      notes: "Primary passport acceptance facility serving Vermillion, USD, and Clay County. Passport photos available. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "vermillion-2",
      name: "Clay County Clerk of Courts",
      type: "County Clerk Passport Acceptance",
      address: "211 W Main St",
      city: "Vermillion",
      state: "SD",
      zip: "57069",
      phone: "(605) 677-6756",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "Clay County Courthouse, Downtown Vermillion",
      website: "https://www.claycountysd.org/",
      websiteLabel: "Clay County",
      notes: "County clerk office offering passport acceptance services. Convenient for downtown Vermillion residents and USD students. Call ahead to confirm clerk availability.",
      icon: "ri-government-line",
    },
    {
      id: "vermillion-3",
      name: "Yankton Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "506 W 25th St",
      city: "Yankton",
      state: "SD",
      zip: "57078",
      phone: "(605) 665-2567",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Yankton — 26 miles west",
      website: "https://tools.usps.com/find-location.htm?location=1368583",
      websiteLabel: "USPS Location",
      notes: "Alternative acceptance facility serving Yankton County. Passport photos available. Convenient for western Clay County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "vermillion-4",
      name: "Sioux City Downtown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "320 Nebraska St",
      city: "Sioux City",
      state: "IA",
      zip: "51101",
      phone: "(712) 277-6301",
      hours: "Mon–Fri 9:00 AM – 4:30 PM (appointment required)",
      distance: "Sioux City, IA — 35 miles south via I-29",
      website: "https://tools.usps.com/find-location.htm?location=1368204",
      websiteLabel: "USPS Location",
      notes: "Larger acceptance facility across the border in Iowa. Full photo services. More appointment availability than rural South Dakota post offices. Near Sioux Gateway Airport (SUX).",
      icon: "ri-mail-line",
    },
    {
      id: "vermillion-5",
      name: "Elk Point Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "106 W Main St",
      city: "Elk Point",
      state: "SD",
      zip: "57025",
      phone: "(605) 356-2461",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Elk Point — 15 miles north",
      website: "https://tools.usps.com/find-location.htm?location=1368571",
      websiteLabel: "USPS Location",
      notes: "Alternative acceptance facility for Union County residents. Limited hours — call ahead to confirm availability and photo services.",
      icon: "ri-mail-line",
    },
    {
      id: "vermillion-6",
      name: "Sioux Falls Downtown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "320 S 2nd Ave",
      city: "Sioux Falls",
      state: "SD",
      zip: "57104",
      phone: "(605) 336-3343",
      hours: "Mon–Fri 9:00 AM – 4:30 PM (appointment required)",
      distance: "Sioux Falls — 60 miles north via I-29",
      website: "https://tools.usps.com/find-location.htm?location=1368468",
      websiteLabel: "USPS Location",
      notes: "Largest acceptance facility in the region. Full photo services and more appointment availability than smaller rural post offices. Convenient if combining with a Sioux Falls trip.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 280 miles to Minneapolis Passport Agency", fpc: "Most Vermillion travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "SD-Specific Guidance", agency: "Generic — no USD, Missouri River, or southeastern SD expertise", fpc: "Full USD/Clay County/southeastern SD knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "USD Study Abroad Deadline Rush",
      description: "USD students frequently apply for first-time passports just 2–3 weeks before study abroad departure. First-time applications require an acceptance facility visit plus processing time — start at least 8 weeks before departure.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Vermillion applicants often attempt the simpler renewal form when their passport was issued at 15 or younger. A rejected form costs 1–2 weeks. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations",
      description: "Many Vermillion pharmacy and retail store photos fail State Department standards. We catch this in review before it causes a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Minors",
      description: "Clay County families frequently overlook the DS-3053 consent form when one parent is unavailable. This is an automatic rejection — we guide you through it correctly.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Cross-Border to Iowa Assumptions",
      description: "Vermillion residents often cross into Iowa for shopping, dining, and flights from SUX. Some assume a passport is not needed for international connecting flights from Sioux City — it is. We clarify requirements based on your specific itinerary.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home, office, or USD dorm." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Vermillion clients ship from the USD campus mail center or the UPS Store in Yankton — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 280 miles to Minneapolis or wait at a rural post office." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Vermillion?", a: "We offer Vermillion-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Do I need to visit an office in Vermillion?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (the Vermillion post office or Clay County Clerk), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Vermillion address." },
    { q: "Where can I get passport acceptance in Vermillion?", a: "Vermillion has passport acceptance at the Main Post Office (16 N Dakota St) and the Clay County Clerk of Courts (211 W Main St). Nearby options include post offices in Yankton, Elk Point, and Sioux City (IA)." },
    { q: "Can USD students get expedited passports?", a: "Yes. University of South Dakota Coyotes participating in study abroad, international research, service learning, or athletic recruiting trips can use our expedited courier service. We understand university timelines and can process first-time and renewal passports before program departure dates." },
    { q: "Can I use Sioux City or Sioux Falls airports from Vermillion?", a: "Yes. Sioux Gateway Airport (SUX) in Sioux City, IA is 35 miles south with connections to ORD and DEN. Sioux Falls Regional Airport (FSD) is 60 miles north with connections to MSP, ORD, DEN, and DFW. Both provide access to international gateways within a one-hour drive." },
    { q: "What documents do Vermillion applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Vermillion-specific checklist." },
    { q: "Can I get a passport photo in Vermillion?", a: "Yes — the Vermillion Main Post Office offers passport photos on-site. Additional photo locations include Lewis Drug, Walmart, and Walgreens. The USD campus store may also offer photo services during the academic year. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How far is the nearest passport agency from Vermillion?", a: "The Minneapolis Passport Agency (212 3rd Ave S, Minneapolis, MN) is approximately 280 miles northeast of Vermillion via I-29. It requires appointments for life-or-death emergencies only. For travel within 3–14 days, our registered courier service is the fastest legally available channel." },
    { q: "How do I check my Vermillion passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Vermillion to final return shipping typically matches your chosen speed tier." },
    { q: "Does USD academic calendar affect passport processing?", a: "The academic calendar creates two peak passport periods: August–September (fall semester study abroad and new student international orientation) and December–January (spring semester programs and holiday travel). Plan around these peaks for faster processing." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Vermillion Residents",
    intro: "Vermillion's identity as a university town on the Missouri River creates unique passport timing challenges. Here's what Vermillion travelers need to know.",
    cards: [
      {
        icon: "ri-graduation-cap-line",
        title: "University of South Dakota International Programs",
        subtitle: "USD study abroad, research, and Coyote international travel",
        description: "USD is the heart of Vermillion, and its international programs send hundreds of students and faculty abroad each year. The university offers study abroad programs across Europe, Asia, and Latin America. Faculty present research at international conferences, and the athletic department recruits internationally. The challenge: first-time student applicants often start the process too late, creating emergency situations.",
        tip: "USD students: apply for your passport the moment you commit to a study abroad program — not when the packing list arrives. First-time applications need an acceptance facility visit plus processing time.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "Dual Airport Strategy — SUX & FSD",
        subtitle: "Two regional airports within an hour drive",
        description: "Vermillion residents benefit from two regional airports: Sioux Gateway Airport in Sioux City (SUX, 35 miles south) and Sioux Falls Regional Airport (FSD, 60 miles north). SUX offers United connections through ORD and DEN. FSD offers American, Delta, and United connections through MSP, ORD, DEN, and DFW. Having two options gives Vermillion travelers flexibility when booking international connections.",
        tip: "Check flight schedules from both SUX and FSD when planning international trips. SUX can be more convenient for southern Clay County residents, while FSD offers more frequency and direct-flight options.",
      },
      {
        icon: "ri-anchor-line",
        title: "Missouri River Recreation & Tourism",
        subtitle: "Missouri National Recreational River and cross-border recreation",
        description: "Vermillion sits along the Missouri National Recreational River, which draws outdoor enthusiasts for kayaking, fishing, and boating. Many river recreation professionals attend international conferences and trade shows in Canada and Europe. The Missouri River also creates cross-border recreational connections with Nebraska and Iowa.",
        tip: "Recreation professionals traveling to Canada: check passport validity during the off-season (October–March) when schedules are more flexible.",
      },
      {
        icon: "ri-road-map-line",
        title: "Southeastern SD & Tri-State Connections",
        subtitle: "Clay County, Yankton, and Siouxland region travel patterns",
        description: "Vermillion's position at the intersection of South Dakota, Nebraska, and Iowa creates a tristate travel region. Many Vermillion residents have family, business, and recreational connections across all three states. International travel often routes through Sioux City (IA), Omaha (NE), or Sioux Falls (SD) — understanding these regional patterns helps us plan realistic passport timelines.",
        tip: "If combining international travel with visits to Omaha or Sioux Falls, consider processing your passport through whatever city you visit most frequently for mailing and shipping convenience.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Vermillion & the USD Economic Impact",
      description: "The University of South Dakota dominates Vermillion's economy and international travel demand. USD's academic calendar (August–May) creates predictable peaks for passport services — with August–September and December–January being the busiest periods.",
    },
  },
  destinations: {
    title: "Where Vermillion Travelers Go — And Why Passports Get Urgent",
    intro: "Vermillion's mix of university travel, Missouri River recreation, and southeastern South Dakota family heritage creates diverse passport needs. Here are the most common international destinations and the urgency patterns we see.",
    stats: [
      { stat: "45%", label: "of Vermillion expedited requests are USD study abroad or academic conference-related" },
      { stat: "2–4 Weeks", label: "average lead time for USD students applying for first-time passports before study abroad" },
      { stat: "Aug–Sep", label: "peak season when fall semester study abroad and new student orientations overlap" },
      { stat: "280 Miles", label: "distance Vermillion residents avoid by using our courier instead of driving to the Minneapolis agency" },
    ],
    destinations: [
      { name: "Guatemala & Honduras", context: "USD medical service trips, public health programs, community development", urgency: "Service trip deadlines with 4–8 week advance notice", icon: "ri-map-pin-2-line" },
      { name: "Germany & Austria", context: "USD exchange programs, medical research conferences, music and arts programs", urgency: "Conference dates fixed — 3–6 week planning typical", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom & Ireland", context: "USD law and business exchanges, family heritage travel, academic conferences", urgency: "Summer programs booked 2–3 months in advance", icon: "ri-map-pin-2-line" },
      { name: "France & Italy", context: "USD arts and humanities programs, graduate research, family heritage trips", urgency: "Semester abroad deadlines — 8–12 week lead time ideal", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Missouri River management conferences, outdoor recreation trade shows, family trips", urgency: "Summer conference season May–August, passport card popular", icon: "ri-map-pin-2-line" },
      { name: "Vietnam & Thailand", context: "Family heritage travel strong in Clay County's diverse communities, USD Asian studies", urgency: "Long-lead planning but visa processes take additional time", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other South Dakota Service Areas",
    crossLinksDesc: "We serve travelers across the Mount Rushmore State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Sioux Falls", route: "/sioux-falls" },
      { name: "Yankton", route: "/yankton" },
      { name: "Brookings", route: "/brookings" },
    ],
  },
  photoLocations: [
    { name: "Vermillion Main Post Office", address: "16 N Dakota St, Vermillion, SD 57069", hours: "Mon–Fri 9 AM – 4 PM" },
    { name: "Lewis Drug — Vermillion", address: "525 W Cherry St, Vermillion, SD 57069", hours: "Mon–Fri 8 AM – 9 PM, Sat–Sun 9 AM – 6 PM" },
    { name: "Walmart Supercenter — Vermillion", address: "1207 Princeton St, Vermillion, SD 57069", hours: "Daily 7 AM – 11 PM" },
    { name: "Walgreens — Vermillion", address: "809 E Cherry St, Vermillion, SD 57069", hours: "Daily 8 AM – 10 PM" },
    { name: "UPS Store — Yankton", address: "2101 Broadway Ave, Yankton, SD 57078", hours: "Mon–Fri 8 AM – 6 PM, Sat 9 AM – 2 PM" },
    { name: "Yankton Post Office", address: "506 W 25th St, Yankton, SD 57078", hours: "Mon–Fri 9 AM – 4 PM" },
    { name: "Sioux City Downtown Post Office", address: "320 Nebraska St, Sioux City, IA 51101", hours: "Mon–Fri 9 AM – 4:30 PM" },
    { name: "FedEx Office — Sioux Falls", address: "3400 W 49th St, Sioux Falls, SD 57106", hours: "Mon–Fri 7:30 AM – 9 PM, Sat 9 AM – 6 PM" },
  ],
  dmvLocations: [
    {
      name: "Yankton DPS Driver License Exam Station",
      address: "3113 Spruce St, Yankton, SD 57078",
      hours: "Mon–Fri, 7:00 AM – 5:30 PM",
      note: "Nearest DPS exam station to Vermillion. Driver licenses, REAL ID, written and road tests. Appointment recommended. About a 25-minute drive from Vermillion.",
      featured: true,
    },
    {
      name: "Sioux Falls DPS Driver License Exam Station",
      address: "3101 W Russell St, Sioux Falls, SD 57107",
      hours: "Mon–Fri, 7:00 AM – 5:30 PM",
      note: "Full-service DPS driver license office serving Minnehaha County. REAL ID available. Appointment strongly recommended.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "SUX",
      name: "Sioux Gateway Airport",
      distance: "About 35 miles south of Vermillion via I-29",
      address: "2403 Aviation Blvd, Sioux City, IA 51111",
      note: "Closest airport to Vermillion. United Express flights to ORD and DEN — both major international gateways. About a 35-minute drive from downtown Vermillion.",
      flightUrl: "https://www.flysux.com/",
      flightLabel: "SUX Airport Website",
      featured: true,
    },
    {
      code: "FSD",
      name: "Sioux Falls Regional Airport (Joe Foss Field)",
      distance: "About 60 miles north of Vermillion via I-29",
      address: "2801 N Jaycee Ln, Sioux Falls, SD 57104",
      note: "Largest airport in South Dakota. Daily nonstop connections to MSP, ORD, DEN, and DFW — all major international gateways. About a one-hour drive from Vermillion.",
      flightUrl: "https://www.sfairport.com/",
      flightLabel: "FSD Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the South Dakota Department of Health Vital Records. Online, mail, or in-person options available.",
      url: "https://doh.sd.gov/records/stillbirth.aspx",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through SD Department of Health Vital Records. Required for estate and legal matters.",
      url: "https://doh.sd.gov/records/stillbirth.aspx",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Clay County Register of Deeds. Certified copies available for name changes and legal purposes.",
      url: "https://www.claycountysd.org/departments/register-of-deeds",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Clay County Clerk of Courts. Required for name change passport corrections.",
      url: "https://www.claycountysd.org/departments/clerk-of-courts",
    },
  ],
};